import { render, staticRenderFns } from "./myResourceStoreManageList.vue?vue&type=template&id=5ba8929c&scoped=true"
import script from "./myResourceStoreManageList.vue?vue&type=script&lang=js"
export * from "./myResourceStoreManageList.vue?vue&type=script&lang=js"
import style0 from "./myResourceStoreManageList.vue?vue&type=style&index=0&id=5ba8929c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba8929c",
  null
  
)

export default component.exports